<template>
  <div>
    <baseFrame
      submitText=""
      clearText=""
      saveText="">
      <div slot="content">
        <lk-card title="养护规则信息">
          <!-- isDefaultRule 编辑默认的养护规则 -->
          <lk-form
            v-if="isDefaultRule"
            :label-width="134"
            :model="curingRuleDefault"
            ref="curingRuleDefaultForm">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="规则名称:">
                  <span>{{curingRuleDefault.name}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护标准:">
                  <span>{{standardMap.get(curingRuleDefault.standard)}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护周期:">
                  <span>{{curingRuleDefault.cycle}}天</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护范围:">
                  <span>{{curingRuleDefault.warehouseNames}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护提醒:" >
                  <span>{{curingRuleDefault.alertDays}}天</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
          <lk-form
            v-else
            :label-width="134"
            :model="curingRule"
            ref="curingRuleForm">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="规则名称:">
                  <span>{{curingRule.name}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护标准:">
                  <span>{{standardMap.get(curingRule.standard)}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护周期:">
                  <span>{{curingRule.cycle}}天</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护提醒:">
                  <span>{{curingRule.alertDays}}天</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="优先级:">
                  <span>{{priorityMap.get(curingRule.priority)}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="开始时间:">
                  <span>{{curingRule.startTime | formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="结束时间:">
                  <span>{{curingRule.endTime | formatDate}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="使用状态:">
                  <span>{{statusMap.get(curingRule.status)}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护范围:">
                  <div>
                    <lk-checkbox :true-value="1" :false-value="2" v-model="curingRule.containExpiry" disabled>近效期商品</lk-checkbox>
                    <lk-checkbox :true-value="1" :false-value="2" v-model="curingRule.containExpensive" disabled>性状不稳定、贵细商品</lk-checkbox>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="养护商品:">
                  <lk-table border :columns="columns" :data="tableData"></lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';

export default {
  name: 'curingRuleView',
  components: {
    baseFrame,
  },
  computed: {},
  data() {
    return {
      curingRule: {},
      columns: [
        { title: '序号', type: 'index', width: 60 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '助记码', key: 'mnemonicCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugName', minWidth: 110 },
        { title: '规格', key: 'spec', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnitString', minWidth: 110 },
        { title: '生产厂家', key: 'producer', minWidth: 110 },
        { title: '剂型', key: 'dosageFormName', minWidth: 110 },
      ],
      tableData: [],
      priorityMap: new Map([
        [1, '低'],
        [2, '中'],
        [3, '高'],
      ]),
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      curingRuleId: null,
      isDefaultRule: false,
      curingRuleDefault: {},
      standardMap: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      warehouses: [],
    };
  },
  methods: {
    getWarehouses() {
      return inventory.warehouseList({
        warehouseType: 1, // 1合格库 2退货区 3不合格品库
      }).then((res) => {
        if (res.data.status === 200) {
          res.data.data.list.forEach((item) => {
            const warehouse = {};
            warehouse.id = item.id;
            warehouse.name = item.warehouseName;
            this.warehouses.push(warehouse);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleToCuringRuleList() {
      this.$router.push({ name: 'curingRule' });
    },
  },
  created() {
    this.curingRuleId = this.$route.params.id;
    if (this.curingRuleId) {
      this.getWarehouses(); // 查找仓库
      inventory.getCuringRuleById({ ruleId: this.curingRuleId }).then((res) => {
        if (res.data.status === 200) {
          const { curingRule, goodsInfoVoList } = res.data.data;
          if (curingRule.defaultFlag === 1) { // 默认养护规则
            this.isDefaultRule = true;
            this.curingRuleDefault = curingRule;
          } else {
            // 历史数据： 自定义的养护规则中，养护商品不为空的，将养护范围“性状不稳定、贵细商品”勾选
            if (goodsInfoVoList && goodsInfoVoList.length > 0) {
              curingRule.containExpensive = 1;
            }
            this.curingRule = curingRule;
            this.tableData = goodsInfoVoList || [];
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
